var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutter" },
            [_c("back-button", { attrs: { returnUrl: "/security/-1" } })],
            1
          ),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-start" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: "",
                              inputLabel: _vm.$t("common.nme"),
                            },
                            model: {
                              value: _vm.configurationConfig.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.configurationConfig, "name", $$v)
                              },
                              expression: "configurationConfig.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-start" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: "",
                              inputLabel: _vm.$t("common.type_label"),
                            },
                            model: {
                              value: _vm.configurationConfig.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.configurationConfig, "type", $$v)
                              },
                              expression: "configurationConfig.type",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.type === "CMS"
                    ? _c(
                        "b-row",
                        { staticClass: "form-group" },
                        [
                          _vm.configurationConfig.role === "0"
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.global.verification")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "checkbox-group-1",
                                        disabled: _vm.formType === "view",
                                        stacked: "",
                                      },
                                      model: {
                                        value: _vm.selectedVerif,
                                        callback: function ($$v) {
                                          _vm.selectedVerif = $$v
                                        },
                                        expression: "selectedVerif",
                                      },
                                    },
                                    _vm._l(
                                      _vm.listVerifSMIME,
                                      function (modeSecurity) {
                                        return _c(
                                          "b-form-checkbox",
                                          {
                                            key: modeSecurity.id,
                                            style: modeSecurity.style,
                                            attrs: {
                                              id:
                                                "modeSecurity_" +
                                                modeSecurity.id,
                                              disabled: modeSecurity.disabled,
                                              value: modeSecurity.value,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(modeSecurity.text) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("common.global.sign"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "checkbox-group-2",
                                        disabled: _vm.formType === "view",
                                        stacked: "",
                                      },
                                      model: {
                                        value: _vm.selectedVerif,
                                        callback: function ($$v) {
                                          _vm.selectedVerif = $$v
                                        },
                                        expression: "selectedVerif",
                                      },
                                    },
                                    _vm._l(
                                      _vm.listSignSMIME,
                                      function (modeSecurity) {
                                        return _c(
                                          "b-form-checkbox",
                                          {
                                            key: modeSecurity.id,
                                            style: modeSecurity.style,
                                            attrs: {
                                              id:
                                                "modeSecurity_" +
                                                modeSecurity.id,
                                              disabled: modeSecurity.disabled,
                                              value: modeSecurity.value,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(modeSecurity.text) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "SSL"
                    ? _c(
                        "b-row",
                        { staticClass: "form-group" },
                        [
                          _vm.configurationConfig.role === "0"
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.global.client_colleague")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "checkbox-group-1",
                                        disabled: _vm.formType === "view",
                                        stacked: "",
                                      },
                                      model: {
                                        value: _vm.selectedVerif,
                                        callback: function ($$v) {
                                          _vm.selectedVerif = $$v
                                        },
                                        expression: "selectedVerif",
                                      },
                                    },
                                    _vm._l(
                                      _vm.listVerifClientSSL,
                                      function (modeSecurity) {
                                        return _c(
                                          "b-form-checkbox",
                                          {
                                            key: modeSecurity.id,
                                            style: modeSecurity.style,
                                            attrs: {
                                              id:
                                                "modeSecurity_" +
                                                modeSecurity.id,
                                              disabled: modeSecurity.disabled,
                                              value: modeSecurity.value,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(modeSecurity.text) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.global.client_local")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "checkbox-group-2",
                                        disabled: _vm.formType === "view",
                                        stacked: "",
                                      },
                                      model: {
                                        value: _vm.selectedVerif,
                                        callback: function ($$v) {
                                          _vm.selectedVerif = $$v
                                        },
                                        expression: "selectedVerif",
                                      },
                                    },
                                    _vm._l(
                                      _vm.listVerifServerSSL,
                                      function (modeSecurity) {
                                        return _c(
                                          "b-form-checkbox",
                                          {
                                            key: modeSecurity.id,
                                            style: modeSecurity.style,
                                            attrs: {
                                              id:
                                                "modeSecurity_" +
                                                modeSecurity.id,
                                              disabled: modeSecurity.disabled,
                                              value: modeSecurity.value,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(modeSecurity.text) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _vm.configurationConfig.role === "0"
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.global.server_local")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "checkbox-group-2",
                                        disabled: _vm.formType === "view",
                                        stacked: "",
                                      },
                                      model: {
                                        value: _vm.selectedVerif,
                                        callback: function ($$v) {
                                          _vm.selectedVerif = $$v
                                        },
                                        expression: "selectedVerif",
                                      },
                                    },
                                    _vm._l(
                                      _vm.listVerifServerSSL,
                                      function (modeSecurity) {
                                        return _c(
                                          "b-form-checkbox",
                                          {
                                            key: modeSecurity.id,
                                            style: modeSecurity.style,
                                            attrs: {
                                              id:
                                                "modeSecurity_" +
                                                modeSecurity.id,
                                              disabled: modeSecurity.disabled,
                                              value: modeSecurity.value,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(modeSecurity.text) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.global.server_colleague")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      attrs: {
                                        id: "checkbox-group-2",
                                        disabled: _vm.formType === "view",
                                        stacked: "",
                                      },
                                      model: {
                                        value: _vm.selectedVerif,
                                        callback: function ($$v) {
                                          _vm.selectedVerif = $$v
                                        },
                                        expression: "selectedVerif",
                                      },
                                    },
                                    _vm._l(
                                      _vm.listVerifClientSSL,
                                      function (modeSecurity) {
                                        return _c(
                                          "b-form-checkbox",
                                          {
                                            key: modeSecurity.id,
                                            style: modeSecurity.style,
                                            attrs: {
                                              id:
                                                "modeSecurity_" +
                                                modeSecurity.id,
                                              disabled: modeSecurity.disabled,
                                              value: modeSecurity.value,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(modeSecurity.text) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-start" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: { disabled: "", inputLabel: "Pod" },
                            model: {
                              value: _vm.configurationConfig.idPod,
                              callback: function ($$v) {
                                _vm.$set(_vm.configurationConfig, "idPod", $$v)
                              },
                              expression: "configurationConfig.idPod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.configurationConfig.storage !== "NONE"
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-start" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("label", [
                                _vm._v("\n            " + _vm._s("Stockage")),
                                _c("span", { staticClass: "color-red" }, [
                                  _vm._v(" * "),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.configurationConfig.storage,
                                      expression: "configurationConfig.storage",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    disabled: true || _vm.formType === "view",
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "storage",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      "Veuillez sélectionner un stockage..."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "PEM" } }, [
                                    _vm._v(_vm._s("PEM")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Volume" } }, [
                                    _vm._v(_vm._s("Volume")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Vault" } }, [
                                    _vm._v(_vm._s("Vault")),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.configurationConfig.storage === "PEM"
                    ? [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t(
                                      "common.security.certificate"
                                    ),
                                    inputType: "textarea",
                                    rows: "3",
                                  },
                                  model: {
                                    value: _vm.configurationConfig.certificate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "certificate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.certificate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t(
                                      "common.security.priv_key"
                                    ),
                                    inputType: "textarea",
                                    rows: "3",
                                  },
                                  model: {
                                    value: _vm.configurationConfig.privateKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "privateKey",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.privateKey",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t("common.pwd"),
                                  },
                                  model: {
                                    value: _vm.configurationConfig.password,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "password",
                                        $$v
                                      )
                                    },
                                    expression: "configurationConfig.password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm.configurationConfig.storage === "Vault"
                    ? [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t(
                                      "common.security.certificate"
                                    ),
                                  },
                                  model: {
                                    value: _vm.configurationConfig.certificate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "certificate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.certificate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t(
                                      "common.security.priv_key"
                                    ),
                                  },
                                  model: {
                                    value: _vm.configurationConfig.privateKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "privateKey",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.privateKey",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t("common.pwd"),
                                  },
                                  model: {
                                    value: _vm.configurationConfig.password,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "password",
                                        $$v
                                      )
                                    },
                                    expression: "configurationConfig.password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: "Vault config name",
                                  },
                                  model: {
                                    value:
                                      _vm.configurationConfig.vaultConfigName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "vaultConfigName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.vaultConfigName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: "Vault secrets type",
                                  },
                                  model: {
                                    value:
                                      _vm.configurationConfig.vaultSecretsType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "vaultSecretsType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.vaultSecretsType",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: "Vault secrets path",
                                  },
                                  model: {
                                    value:
                                      _vm.configurationConfig.vaultSecretsPath,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "vaultSecretsPath",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.vaultSecretsPath",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm.configurationConfig.storage === "Volume"
                    ? [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t(
                                      "common.security.p12File"
                                    ),
                                    inputType: "text",
                                    rows: "3",
                                  },
                                  model: {
                                    value: _vm.configurationConfig.p12File,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "p12File",
                                        $$v
                                      )
                                    },
                                    expression: "configurationConfig.p12File",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group pb-3",
                                attrs: { sm: "6" },
                              },
                              [
                                _c("label", [_vm._v("Variable")]),
                                _vm._v(" "),
                                _c(
                                  "b-form-radio-group",
                                  {
                                    attrs: {
                                      disabled: _vm.formType === "view",
                                    },
                                    model: {
                                      value:
                                        _vm.configurationConfig.variableP12File,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.configurationConfig,
                                          "variableP12File",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "configurationConfig.variableP12File",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          name: "variableP12File-radio",
                                          value: "ENV",
                                        },
                                      },
                                      [_vm._v("ENV")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          name: "variableP12File-radio",
                                          value: "OTHER",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.other")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t(
                                      "common.security.p12PwdFile"
                                    ),
                                    inputType: "text",
                                    rows: "3",
                                  },
                                  model: {
                                    value: _vm.configurationConfig.p12PwdFile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "p12PwdFile",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.p12PwdFile",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group pb-3",
                                attrs: { sm: "6" },
                              },
                              [
                                _c("label", [_vm._v("Variable")]),
                                _vm._v(" "),
                                _c(
                                  "b-form-radio-group",
                                  {
                                    attrs: {
                                      disabled: _vm.formType === "view",
                                    },
                                    model: {
                                      value:
                                        _vm.configurationConfig
                                          .variableP12PwdFile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.configurationConfig,
                                          "variableP12PwdFile",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "configurationConfig.variableP12PwdFile",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          name: "variableP12PwdFile-radio",
                                          value: "ENV",
                                        },
                                      },
                                      [_vm._v("ENV")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          name: "variableP12PwdFile-radio",
                                          value: "OTHER",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.other")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled: _vm.formType === "view",
                                    inputLabel: _vm.$t(
                                      "common.security.p12PwdInsideFile"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.configurationConfig.p12PwdInsideFile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configurationConfig,
                                        "p12PwdInsideFile",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configurationConfig.p12PwdInsideFile",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group pb-3",
                                attrs: { sm: "6" },
                              },
                              [
                                _c("label", [_vm._v("Variable")]),
                                _vm._v(" "),
                                _c(
                                  "b-form-radio-group",
                                  {
                                    attrs: {
                                      disabled: _vm.formType === "view",
                                    },
                                    model: {
                                      value:
                                        _vm.configurationConfig
                                          .variableP12PwdInsideFile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.configurationConfig,
                                          "variableP12PwdInsideFile",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "configurationConfig.variableP12PwdInsideFile",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          name: "variableP12PwdInsideFile-radio",
                                          value: "ENV",
                                        },
                                      },
                                      [_vm._v("ENV")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          name: "variableP12PwdInsideFile-radio",
                                          value: "OTHER",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.other")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : void 0,
                ],
                2
              ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-end no-gutter" },
            [
              _vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.switchMode("view")
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("common.cncl")))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.switchMode("edit")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("administration.edit"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.editConfiguration },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }